import qs from 'query-string';
import { PseudoHttpError } from 'shared/universal/custom-errors';
import { selectedStoreSelector } from 'shared/app/state/selectors/ordering';
import { localeTagSelector } from 'shared/app/state/selectors/locales';

import {
  FETCH_MENU,
  FETCH_MENU_SUCCESS,
  FETCH_MENU_ERROR,
} from './action-types';
import { getUrlWithQuery, getShortStoreNumber } from './util/get-filter-query';
import { getDemystifyMenuFeatureFlag } from 'shared/app/utils/feature-flags';
import { VARIATIONS } from 'shared/app/components/optimizely/optimizely-keys';

export const baseMenuPath = '/apiproxy/v1/ordering/menu';

export const fetchMenu =
  () =>
  async (dispatch, getState, { apiFetch }) => {
    const state = getState();
    const {
      ownershipTypeCode,
      timeZone: storeTimeZone,
      storeNumber: selectedStoreNumber,
    } = selectedStoreSelector(state)?.store || {};
    const locale = localeTagSelector(state);
    const storeNumber = getShortStoreNumber(selectedStoreNumber);

    const options = {
      headers: {
        'Accept-Language': locale,
      },
    };

    dispatch({
      type: FETCH_MENU,
      payload: {
        storeNumber: selectedStoreNumber,
      },
    });

    const { isFeatureFlagEnabled: isDemystifyMenuEnabled, variationKey } =
      await getDemystifyMenuFeatureFlag();

    const timeZone = storeTimeZone?.timeZoneId;
    const queryParameters = qs.stringify(
      {
        storeNumber,
        // Prevents sending isPricingEnabled with a false value,
        // as it's already defaulted to false on the BFF side.
        // Additionally, this avoids exposing the fact that we're passing a feature flag to the BFF.
        isPricingEnabled:
          (isDemystifyMenuEnabled &&
            variationKey === VARIATIONS.SHOW_PRICING_ON_MENU_AND_PDP) ||
          '',
        ownershipTypeCode,
        timeZone,
      },
      { skipEmptyString: true }
    );

    const url = getUrlWithQuery(baseMenuPath, queryParameters);

    return apiFetch(url, options)
      .then((data) => {
        const payload = data?.menus;

        dispatch({
          type: FETCH_MENU_SUCCESS,
          payload,
        });
      })
      .catch((err) => {
        // If we get something directly from fetch, we likely have deeper connection problems,
        // so we default to 503 Service Unavailable
        const status = err.status || 503;
        const httpError = new PseudoHttpError({
          code: status,
          message: `Got ${status} from ${url}`,
        });
        dispatch({
          type: FETCH_MENU_ERROR,
          error: httpError,
        });
      });
  };
